import { render, staticRenderFns } from "./TagsInCard.vue?vue&type=template&id=6dd8ec58&scoped=true&"
import script from "./TagsInCard.vue?vue&type=script&lang=ts&"
export * from "./TagsInCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8ec58",
  null
  
)

export default component.exports